/**
 * Smoke Perks Review Drawer — Singleton drawer for collection page review previews + inline form.
 * Extracted from card-product.liquid for performance.
 * Loaded with defer from theme.liquid.
 */
(function() {
  'use strict';
  if (document.getElementById('perks-preview-overlay')) return;

  var _slogo = 'https://cdn.shopify.com/s/files/1/0913/0967/0716/files/Reviews_Stars.png?v=1774378184';

  var ov = document.createElement('div');
  ov.className = 'ocs-perks-overlay';
  ov.id = 'perks-preview-overlay';
  ov.innerHTML =
    '<div class="ocs-perks-drawer" id="perks-preview-drawer" data-rc-dark role="dialog" aria-modal="true" aria-label="Review preview">' +
      '<div class="ocs-perks-drawer-hdr">' +
        '<div><div class="ocs-perks-drawer-title" id="ppd-title"></div>' +
        '<div class="ocs-perks-drawer-rating" id="ppd-rating"></div></div>' +
        '<button class="ocs-perks-drawer-close" id="ppd-close">&times;</button>' +
      '</div>' +
      '<div id="ppd-view-reviews">' +
        '<div class="ocs-perks-drawer-insights" id="ppd-insights"></div>' +
        '<div class="ocs-perks-drawer-reviews" id="ppd-reviews"></div>' +
        '<div style="display:flex;gap:0.5rem;">' +
          '<a class="ocs-perks-drawer-cta" id="ppd-cta" href="#" style="flex:1;">View full reviews</a>' +
          '<button class="ocs-perks-drawer-cta" id="ppd-write-btn" style="flex:1;background:rgba(255,255,255,0.08);border:1px solid rgba(255,255,255,0.15);box-shadow:none;" type="button">Write a review</button>' +
        '</div>' +
      '</div>' +
      '<div id="ppd-view-form" style="display:none;">' +
        '<div id="ppd-form-msg"></div>' +
        '<div class="ocs-perks-drawer-form-step" id="ppd-step1">' +
          '<div style="font-size:0.72rem;font-weight:700;color:#c9a0ff;text-transform:uppercase;letter-spacing:0.04em;margin-bottom:0.5rem;">Rate this product</div>' +
          '<div id="ppd-stars" style="display:flex;gap:6px;margin-bottom:0.75rem;">' +
            '<button type="button" data-v="1" style="background:none;border:none;cursor:pointer;padding:0;opacity:0.2;transition:opacity 0.12s;"><img src="' + _slogo + '" style="width:24px;height:24px;max-width:24px;max-height:24px;display:block;object-fit:contain;" alt=""></button>' +
            '<button type="button" data-v="2" style="background:none;border:none;cursor:pointer;padding:0;opacity:0.2;transition:opacity 0.12s;"><img src="' + _slogo + '" style="width:24px;height:24px;max-width:24px;max-height:24px;display:block;object-fit:contain;" alt=""></button>' +
            '<button type="button" data-v="3" style="background:none;border:none;cursor:pointer;padding:0;opacity:0.2;transition:opacity 0.12s;"><img src="' + _slogo + '" style="width:24px;height:24px;max-width:24px;max-height:24px;display:block;object-fit:contain;" alt=""></button>' +
            '<button type="button" data-v="4" style="background:none;border:none;cursor:pointer;padding:0;opacity:0.2;transition:opacity 0.12s;"><img src="' + _slogo + '" style="width:24px;height:24px;max-width:24px;max-height:24px;display:block;object-fit:contain;" alt=""></button>' +
            '<button type="button" data-v="5" style="background:none;border:none;cursor:pointer;padding:0;opacity:0.2;transition:opacity 0.12s;"><img src="' + _slogo + '" style="width:24px;height:24px;max-width:24px;max-height:24px;display:block;object-fit:contain;" alt=""></button>' +
          '</div>' +
          '<div style="font-size:0.72rem;font-weight:700;color:#c9a0ff;text-transform:uppercase;letter-spacing:0.04em;margin-bottom:0.4rem;">Effects</div>' +
          '<div id="ppd-fx" class="ppd-chips"><button type="button" data-val="relaxed">Relaxed</button><button type="button" data-val="happy">Happy</button><button type="button" data-val="euphoric">Euphoric</button><button type="button" data-val="sleepy">Sleepy</button><button type="button" data-val="focused">Focused</button><button type="button" data-val="creative">Creative</button><button type="button" data-val="body-high">Body high</button><button type="button" data-val="head-high">Head high</button></div>' +
          '<div style="font-size:0.72rem;font-weight:700;color:#c9a0ff;text-transform:uppercase;letter-spacing:0.04em;margin:0.6rem 0 0.4rem;">Flavor</div>' +
          '<div id="ppd-fl" class="ppd-chips"><button type="button" data-val="gassy">Gassy</button><button type="button" data-val="fruity">Fruity</button><button type="button" data-val="sweet">Sweet</button><button type="button" data-val="earthy">Earthy</button><button type="button" data-val="citrus">Citrus</button><button type="button" data-val="creamy">Creamy</button><button type="button" data-val="herbal">Herbal</button><button type="button" data-val="pine">Pine</button></div>' +
          '<div style="font-size:0.72rem;font-weight:700;color:#c9a0ff;text-transform:uppercase;letter-spacing:0.04em;margin:0.6rem 0 0.4rem;">Best for</div>' +
          '<div id="ppd-bf" class="ppd-chips"><button type="button" data-val="daytime">Daytime</button><button type="button" data-val="evening">Evening</button><button type="button" data-val="weekend">Weekend</button><button type="button" data-val="after-work">After work</button><button type="button" data-val="social">Social</button><button type="button" data-val="sleep">Sleep</button></div>' +
          '<div style="font-size:0.72rem;font-weight:700;color:#c9a0ff;text-transform:uppercase;letter-spacing:0.04em;margin:0.6rem 0 0.4rem;">Would buy again?</div>' +
          '<div id="ppd-buy" style="display:flex;gap:0.35rem;margin-bottom:0.5rem;">' +
            '<button type="button" data-val="true" style="flex:1;padding:0.4rem;border:1px solid rgba(255,255,255,0.1);border-radius:8px;background:rgba(255,255,255,0.06);color:rgba(255,255,255,0.5);font-weight:600;font-size:0.8rem;cursor:pointer;">Yes</button>' +
            '<button type="button" data-val="false" style="flex:1;padding:0.4rem;border:1px solid rgba(255,255,255,0.1);border-radius:8px;background:rgba(255,255,255,0.06);color:rgba(255,255,255,0.5);font-weight:600;font-size:0.8rem;cursor:pointer;">No</button>' +
          '</div>' +
        '</div>' +
        '<div style="margin-top:0.6rem;">' +
          '<input id="ppd-title-input" type="text" maxlength="200" placeholder="e.g. Smooth evening smoke" required style="width:100%;padding:0.5rem 0.6rem;border:1px solid rgba(255,255,255,0.1);border-radius:8px;background:rgba(255,255,255,0.06);color:#fff;font-size:0.82rem;font-family:inherit;box-sizing:border-box;margin-bottom:0.4rem;">' +
          '<textarea id="ppd-body-input" maxlength="2000" placeholder="How was your experience? (min 20 characters)" rows="3" style="width:100%;padding:0.5rem 0.6rem;border:1px solid rgba(255,255,255,0.1);border-radius:8px;background:rgba(255,255,255,0.06);color:#fff;font-size:0.82rem;font-family:inherit;box-sizing:border-box;resize:vertical;"></textarea>' +
        '</div>' +
        '<div style="margin-top:0.6rem;">' +
          '<div style="font-size:0.72rem;font-weight:700;color:#c9a0ff;text-transform:uppercase;letter-spacing:0.04em;margin-bottom:0.4rem;">Add photos (optional)</div>' +
          '<div id="ppd-photo-slots" style="display:flex;gap:0.4rem;flex-wrap:wrap;"></div>' +
          '<div id="ppd-photo-status" style="font-size:0.68rem;color:rgba(255,255,255,0.35);margin-top:0.25rem;min-height:1em;"></div>' +
        '</div>' +
        '<div style="display:flex;gap:0.5rem;margin-top:0.75rem;">' +
          '<button type="button" id="ppd-form-back" class="ocs-perks-drawer-cta" style="flex:1;background:rgba(255,255,255,0.08);border:1px solid rgba(255,255,255,0.15);box-shadow:none;">Back</button>' +
          '<button type="button" id="ppd-form-submit" class="ocs-perks-drawer-cta" style="flex:1;">Submit</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  document.body.appendChild(ov);

  // Use shared dialog helper for open/close/focus trap/Escape/focus return
  var drawerDialog = window.SmokeysDialog.create({
    overlay: ov,
    container: document.getElementById('perks-preview-drawer'),
    openClass: 'open',
    bodyClass: 'perks-drawer-open',
  });

  document.getElementById('ppd-close').addEventListener('click', function() { drawerDialog.close(); });

  function closePreview() { drawerDialog.close(); }

  function stars(n) { var s = ''; for (var i = 1; i <= 5; i++) s += '<img src="' + _slogo + '" style="width:12px!important;height:12px!important;max-width:12px!important;max-height:12px!important;vertical-align:middle;display:inline-block!important;object-fit:contain;' + (i <= n ? '' : 'opacity:0.2;') + '" alt="">'; return s; }

  var _ctxCache = {};
  function lbl(s) { return (s || '').replace(/-/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); }); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }

  function openPreview(el) {
    var d = el.dataset;
    var title = d.productTitle;
    var url = d.productUrl;
    var handle = d.productHandle;
    var rat = parseFloat(d.rating) || 0;
    var cnt = parseInt(d.ratingCount) || 0;
    var summary = {};
    try { summary = JSON.parse(d.summary || '{}'); } catch(e) {}

    document.getElementById('ppd-title').textContent = title;
    if (cnt > 0) {
      document.getElementById('ppd-rating').innerHTML = '<span class="pr-stars">' + stars(Math.round(rat)) + '</span> <strong style="color:#fff">' + rat.toFixed(1) + '</strong> \u00b7 ' + cnt + ' review' + (cnt !== 1 ? 's' : '');
    } else {
      document.getElementById('ppd-rating').innerHTML = '<span style="color:rgba(201,160,255,0.5)">No reviews yet</span>';
    }

    var ih = '';
    function chipGroup(label, items) {
      if (!items || !items.length) return '';
      var h = '<div class="ocs-perks-drawer-group"><span class="ocs-perks-drawer-group-label">' + label + '</span>';
      items.forEach(function(x) { h += '<span class="ocs-perks-drawer-chip rc-' + x + '">' + lbl(x) + '</span>'; });
      return h + '</div>';
    }
    ih += chipGroup('Effects', summary.effects);
    ih += chipGroup('Flavor', summary.flavors);
    ih += chipGroup('Best for', summary.bestFor);
    if (summary.buyAgainPct > 0) ih += '<div class="ocs-perks-drawer-group"><span class="ocs-perks-drawer-chip rc-would-buy-again">' + summary.buyAgainPct + '% would buy again</span></div>';
    document.getElementById('ppd-insights').innerHTML = ih;

    formPid = d.productId; formHandle = handle;

    var ctaEl = document.getElementById('ppd-cta');
    var writeBtn = document.getElementById('ppd-write-btn');
    ctaEl.href = url + '#pr';
    document.getElementById('ppd-view-reviews').style.display = 'block';
    document.getElementById('ppd-view-form').style.display = 'none';
    ctaEl.textContent = cnt > 0 ? 'View full reviews' : 'View product';
    writeBtn.style.display = 'none';

    var reviewsEl = document.getElementById('ppd-reviews');
    var pid = d.productId;

    function renderUnavailableState() {
      writeBtn.style.display = 'none';
      reviewsEl.innerHTML = '<div style="color:rgba(201,160,255,0.7);font-size:0.82rem;padding:1rem 0;text-align:center;">Reviews are being enabled for this product. Please check back soon.</div>';
    }

    function renderReviewCards(data) {
      if (!data || !data.reviews || !data.reviews.length) {
        reviewsEl.innerHTML = '<div style="color:rgba(201,160,255,0.5);font-size:0.82rem;padding:1rem 0;text-align:center;">Be the first to share your experience with this product.</div>';
        return;
      }
      var h = '';
      data.reviews.forEach(function(r) {
        h += '<div class="ocs-perks-drawer-card">' +
          '<div class="ocs-perks-drawer-card-name">' + esc(r.authorFirstName) +
            (r.verified ? ' <span style="font-size:0.55rem;font-weight:700;color:#c9a0ff;background:rgba(107,47,160,0.25);padding:1px 5px;border-radius:3px;border:1px solid rgba(201,160,255,0.15);text-transform:uppercase;letter-spacing:0.03em;vertical-align:middle;margin-left:0.3rem;">Verified</span>' : '') +
          '</div>' +
          '<div class="ocs-perks-drawer-card-stars">' + stars(r.rating) + '</div>' +
          (r.title ? '<div style="font-size:0.75rem;font-weight:700;margin-bottom:0.1rem;">' + esc(r.title) + '</div>' : '') +
          '<div class="ocs-perks-drawer-card-body">' + esc(r.body) + '</div>' +
          (r.photos && r.photos.length ? '<div style="display:flex;gap:0.25rem;margin-top:0.3rem;">' + r.photos.map(function(p) { return '<img src="' + esc(p.thumbUrl || p.photoUrl) + '" style="width:40px;height:40px;border-radius:6px;object-fit:cover;border:1px solid rgba(255,255,255,0.1);" loading="lazy" alt="">'; }).join('') + '</div>' : '') +
        '</div>';
      });
      reviewsEl.innerHTML = h;
    }

    function fetchReviewsForDrawer(rgk) {
      reviewsEl.innerHTML = '<div style="color:rgba(255,255,255,0.3);font-size:0.8rem;padding:0.75rem 0;">Loading\u2026</div>';
      fetch('/apps/ai-rails/get-reviews?reviewGroupKey=' + encodeURIComponent(rgk) + '&limit=6')
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(renderReviewCards)
        .catch(function() { reviewsEl.innerHTML = ''; });
    }

    if (Object.prototype.hasOwnProperty.call(_ctxCache, pid)) {
      if (_ctxCache[pid]) {
        writeBtn.style.display = '';
        fetchReviewsForDrawer(_ctxCache[pid]);
      } else {
        renderUnavailableState();
      }
    } else {
      reviewsEl.innerHTML = '<div style="color:rgba(255,255,255,0.3);font-size:0.8rem;padding:0.75rem 0;">Loading\u2026</div>';
      fetch('/apps/ai-rails/review-context?shopifyProductId=' + encodeURIComponent(pid) + '&handle=' + encodeURIComponent(handle))
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(ctx) {
          if (!ctx || !ctx.reviewGroupKey) {
            _ctxCache[pid] = false;
            renderUnavailableState();
            return;
          }
          _ctxCache[pid] = ctx.reviewGroupKey;
          writeBtn.style.display = '';
          fetchReviewsForDrawer(ctx.reviewGroupKey);
        })
        .catch(function() { reviewsEl.innerHTML = ''; });
    }

    // Dialog helper handles: overlay class, body scroll lock, body class, focus
    // _triggerEl is set by the click delegate below
  }

  // ── Form logic ──
  var formRating = 0, formBuy = null, formPid = '', formHandle = '';
  var formPhotos = [], ppdPhotoUploading = 0, PPD_MAX_PHOTOS = 3, PPD_MAX_SIZE = 5 * 1024 * 1024;

  function ppdUploadPhoto(file) {
    if (formPhotos.length >= PPD_MAX_PHOTOS) { ppdPhotoMsg('Maximum ' + PPD_MAX_PHOTOS + ' photos'); return; }
    if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) { ppdPhotoMsg('JPEG, PNG, or WebP only'); return; }
    if (file.size > PPD_MAX_SIZE) { ppdPhotoMsg('Photo must be under 5MB'); return; }
    var slot = formPhotos.length;
    formPhotos.push({ slot: slot, uploading: true, localUrl: URL.createObjectURL(file) });
    ppdRenderPhotos();
    ppdPhotoUploading++;
    ppdPhotoMsg('Uploading...');
    var reader = new FileReader();
    reader.onload = function () {
      var b64 = reader.result.split(',')[1];
      fetch('/apps/ai-rails/upload-review-photo', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ photoBase64: b64, slot: slot, shopifyProductId: formPid, shopifyProductHandle: formHandle }),
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (r) {
          ppdPhotoUploading--;
          if (r.ok && r.d.ok) { formPhotos[slot] = { slot: slot, photoUrl: r.d.photoUrl, thumbUrl: r.d.thumbUrl }; ppdPhotoMsg(''); }
          else { formPhotos.splice(slot, 1); ppdPhotoMsg(r.d.error || 'Upload failed'); }
          ppdRenderPhotos();
        })
        .catch(function () { ppdPhotoUploading--; formPhotos.splice(slot, 1); ppdRenderPhotos(); ppdPhotoMsg('Upload failed'); });
    };
    reader.readAsDataURL(file);
  }

  function ppdRenderPhotos() {
    var c = document.getElementById('ppd-photo-slots'); if (!c) return;
    c.innerHTML = '';
    formPhotos.forEach(function (p, i) {
      var d = document.createElement('div');
      d.style.cssText = 'position:relative;width:60px;height:60px;border-radius:8px;overflow:hidden;flex-shrink:0;';
      d.innerHTML = '<img src="' + (p.thumbUrl || p.localUrl || '') + '" style="width:60px;height:60px;object-fit:cover;border-radius:8px;border:1px solid rgba(255,255,255,0.1);" alt="">';
      if (p.uploading) {
        d.innerHTML += '<div style="position:absolute;inset:0;background:rgba(0,0,0,0.5);display:flex;align-items:center;justify-content:center;border-radius:8px;"><div style="width:16px;height:16px;border:2px solid rgba(255,255,255,0.3);border-top-color:#fff;border-radius:50%;animation:pr-photo-spin 0.6s linear infinite;"></div></div>';
      } else {
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.style.cssText = 'position:absolute;top:2px;right:2px;width:16px;height:16px;border-radius:50%;background:rgba(0,0,0,0.6);border:none;color:#fff;font-size:0.6rem;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;';
        rm.textContent = '\u00d7';
        (function (idx) { rm.addEventListener('click', function () { formPhotos.splice(idx, 1); ppdRenderPhotos(); ppdPhotoMsg(''); }); })(i);
        d.appendChild(rm);
      }
      c.appendChild(d);
    });
    if (formPhotos.length < PPD_MAX_PHOTOS) {
      var add = document.createElement('label');
      add.style.cssText = 'display:flex;flex-direction:column;align-items:center;justify-content:center;width:60px;height:60px;border:1px dashed rgba(255,255,255,0.2);border-radius:8px;background:rgba(255,255,255,0.04);cursor:pointer;';
      add.innerHTML = '<input type="file" accept="image/jpeg,image/png,image/webp" multiple style="display:none;"><span style="font-size:1.2rem;color:rgba(201,160,255,0.5);line-height:1;">+</span>';
      add.querySelector('input').addEventListener('change', function () { Array.from(this.files || []).forEach(ppdUploadPhoto); this.value = ''; });
      c.appendChild(add);
    }
  }

  function ppdPhotoMsg(t) { var el = document.getElementById('ppd-photo-status'); if (el) el.textContent = t || ''; }

  document.getElementById('ppd-write-btn').addEventListener('click', function() {
    var cidMeta = document.querySelector('meta[name="customer-id"]');
    if (!cidMeta || !cidMeta.content || cidMeta.content === '') {
      window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname);
      return;
    }
    document.getElementById('ppd-view-reviews').style.display = 'none';
    document.getElementById('ppd-view-form').style.display = 'block';
    formRating = 0; formBuy = null;
    document.querySelectorAll('#ppd-stars button').forEach(function(b) { b.style.opacity = '0.2'; });
    document.querySelectorAll('.ppd-chips button').forEach(function(b) { b.classList.remove('on'); });
    document.querySelectorAll('#ppd-buy button').forEach(function(b) { b.style.background = 'rgba(255,255,255,0.06)'; b.style.color = 'rgba(255,255,255,0.5)'; b.style.borderColor = 'rgba(255,255,255,0.1)'; });
    document.getElementById('ppd-title-input').value = '';
    document.getElementById('ppd-body-input').value = '';
    document.getElementById('ppd-form-msg').innerHTML = '';
    formPhotos = []; ppdPhotoUploading = 0; ppdRenderPhotos(); ppdPhotoMsg('');
  });

  document.getElementById('ppd-form-back').addEventListener('click', function() {
    document.getElementById('ppd-view-form').style.display = 'none';
    document.getElementById('ppd-view-reviews').style.display = 'block';
  });

  document.querySelectorAll('#ppd-stars button').forEach(function(btn) {
    btn.addEventListener('click', function() {
      formRating = parseInt(btn.dataset.v);
      document.querySelectorAll('#ppd-stars button').forEach(function(b) {
        b.style.opacity = parseInt(b.dataset.v) <= formRating ? '1' : '0.2';
      });
    });
  });

  document.querySelectorAll('.ppd-chips button').forEach(function(btn) {
    btn.addEventListener('click', function() { btn.classList.toggle('on'); });
  });

  document.querySelectorAll('#ppd-buy button').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var val = btn.dataset.val === 'true';
      formBuy = formBuy === val ? null : val;
      document.querySelectorAll('#ppd-buy button').forEach(function(b) {
        var isThis = b === btn && formBuy !== null;
        if (isThis && formBuy === true) { b.style.background = 'rgba(254,94,2,0.15)'; b.style.color = '#fe5e02'; b.style.borderColor = 'rgba(254,94,2,0.4)'; }
        else if (isThis && formBuy === false) { b.style.background = 'rgba(239,68,68,0.15)'; b.style.color = '#ef4444'; b.style.borderColor = 'rgba(239,68,68,0.4)'; }
        else { b.style.background = 'rgba(255,255,255,0.06)'; b.style.color = 'rgba(255,255,255,0.5)'; b.style.borderColor = 'rgba(255,255,255,0.1)'; }
      });
    });
  });

  document.getElementById('ppd-form-submit').addEventListener('click', function() {
    var msgEl = document.getElementById('ppd-form-msg');
    msgEl.innerHTML = '';
    if (!formRating) { msgEl.innerHTML = '<div style="padding:0.5rem;border-radius:8px;background:rgba(192,57,43,0.15);color:#e57373;font-size:0.8rem;margin-bottom:0.5rem;">Pick a star rating</div>'; return; }
    var titleVal = (document.getElementById('ppd-title-input').value || '').trim();
    if (titleVal.length < 2) { msgEl.innerHTML = '<div style="padding:0.5rem;border-radius:8px;background:rgba(192,57,43,0.15);color:#e57373;font-size:0.8rem;margin-bottom:0.5rem;">Give your review a short title</div>'; return; }
    var body = (document.getElementById('ppd-body-input').value || '').trim();
    if (body.length < 20) { msgEl.innerHTML = '<div style="padding:0.5rem;border-radius:8px;background:rgba(192,57,43,0.15);color:#e57373;font-size:0.8rem;margin-bottom:0.5rem;">Review must be at least 20 characters</div>'; return; }
    if (ppdPhotoUploading > 0) { msgEl.innerHTML = '<div style="padding:0.5rem;border-radius:8px;background:rgba(192,57,43,0.15);color:#e57373;font-size:0.8rem;margin-bottom:0.5rem;">Photos still uploading\u2026</div>'; return; }

    var getChips = function(id) { return Array.from(document.querySelectorAll('#' + id + ' button.on')).map(function(b) { return b.dataset.val; }); };
    var subBtn = document.getElementById('ppd-form-submit');
    subBtn.textContent = 'Submitting\u2026'; subBtn.style.opacity = '0.5';

    fetch('/apps/ai-rails/submit-review', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        rating: formRating, title: document.getElementById('ppd-title-input').value || '', body: body,
        effects: getChips('ppd-fx'), flavorNotes: getChips('ppd-fl'), bestFor: getChips('ppd-bf'),
        wouldBuyAgain: formBuy, photos: formPhotos.filter(function(p) { return p && p.photoUrl; }),
        shopifyProductId: formPid, shopifyProductHandle: formHandle,
      }),
    })
      .then(function(r) { return r.json().then(function(d) { return { ok: r.ok, d: d }; }); })
      .then(function(res) {
        subBtn.textContent = 'Submit'; subBtn.style.opacity = '1';
        if (res.ok) {
          msgEl.innerHTML = '<div style="padding:0.5rem;border-radius:8px;background:rgba(39,174,96,0.15);color:#4ade80;font-size:0.8rem;margin-bottom:0.5rem;">Thanks for your review!</div>';
          setTimeout(function() { closePreview(); }, 1200);
        } else {
          msgEl.innerHTML = '<div style="padding:0.5rem;border-radius:8px;background:rgba(192,57,43,0.15);color:#e57373;font-size:0.8rem;margin-bottom:0.5rem;">' + esc(res.d.error || 'Failed to submit') + '</div>';
        }
      })
      .catch(function() {
        subBtn.textContent = 'Submit'; subBtn.style.opacity = '1';
        msgEl.innerHTML = '<div style="padding:0.5rem;border-radius:8px;background:rgba(192,57,43,0.15);color:#e57373;font-size:0.8rem;margin-bottom:0.5rem;">Network error</div>';
      });
  });

  document.addEventListener('click', function(e) {
    var teaser = e.target.closest('.ocs-perks-teaser');
    if (!teaser) return;
    e.preventDefault();
    e.stopPropagation();
    openPreview(teaser);
    drawerDialog.open(teaser);
  }, true);

  // Keyboard parity with the click delegate: teasers are role="button" divs
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var teaser = e.target.closest('.ocs-perks-teaser');
    if (!teaser) return;
    e.preventDefault();
    e.stopPropagation();
    openPreview(teaser);
    drawerDialog.open(teaser);
  }, true);
})();
